import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=0dde2758&scoped=true&"
import script from "./questionDetail.vue?vue&type=script&lang=js&"
export * from "./questionDetail.vue?vue&type=script&lang=js&"
import style0 from "./questionDetail.vue?vue&type=style&index=0&id=0dde2758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde2758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dde2758')) {
      api.createRecord('0dde2758', component.options)
    } else {
      api.reload('0dde2758', component.options)
    }
    module.hot.accept("./questionDetail.vue?vue&type=template&id=0dde2758&scoped=true&", function () {
      api.rerender('0dde2758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/surveyQquestionnaire/components/questionDetail.vue"
export default component.exports